module.exports = __webpack_public_path__ + "static/media/neha.899511e8.jpeg";